module.exports = __webpack_public_path__ + "img/ro.15da9998.svg";